import React,{useContext} from 'react'
import { makeStyles } from "@material-ui/core/styles";
//import Carousel from "react-simply-carousel";
import Carousel from 'react-material-ui-carousel'

import { Paper } from '@material-ui/core'
import AuthContext from '../../context/authentication/authContext'
import ReceiverContext from '../../context/receiver/ReceiverContext'
import PortalContext from "../../context/portal/portalContext";

const useStyles = makeStyles((theme) => ({
    logoHome:{
        width:'687px',
        height:'184px'
    },
    row:{
        display: "flex",
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'center',
        justifyItems: 'center',

    },
    column: {
      display: "flex",
      flexDirection:'column',
      alignItems:'center'
    },
    blueButton:{
        background:'#001070',
        borderRadius:"4px 4px 4px 4px",
        color:'#FFFFFF',
        margin:'10px',
        border:'0px',
        width:"171px",
        height:"40px",
        fontSize:"14px",
        cursor:'pointer',
        textTransform: "uppercase"
    },
    homeTitle:{
        fontFace:'Inter',
        fontStyle:'normal',
        fontSize:'48px',
        fontWeight:'800',
        color:'#18191F',
        //lineHeight:'98px',
        textTransform:'capitalize'

    },
    homeSubTitle:{
        fontFace:'Inter',
        fontStyle:'normal',
        fontSize:'18px',
        fontWeight:'400',
        color:'#18191F',
        textAlign:'justify'
    },
    banner:{
        width:'518px',
        height:'518px'
    },
    submitButton: {
      color: '#FFFFFF',
      width: '171px',
      border: '0px',
      cursor: 'pointer',
      height: '40px',
      margin: '10px',
      fontSize: '14px',
      background: '#001070',
      borderRadius: '4px 4px 4px 4px',
      textTransform: 'uppercase',
      '&:hover': {
        backgroundColor: '#001070',
        transform: 'translateY(-1px) !important'},
        maxWidth:"460px"

    }
}))


const HomeView = (props)=>{
    const classes = useStyles();
    const authContext = useContext(AuthContext);
    const receiverContext =  useContext(ReceiverContext)

    const portalContext = useContext(PortalContext);
    const { setIsBill,getDashboardData } = portalContext;
    const {
        history
    } = receiverContext
    const {authenticated,authenticatedUser, getTheNews ,news} = authContext;
    React.useEffect(()=>{
        authenticatedUser()
        getTheNews()
        getDashboardData()
    },[])

    const toPage = (page) => {
        history.push(`/app/${page}`);
    };
    const toPortalFactura=()=>{
        setIsBill("ISBILL")
        toPage('portal')
    }
    const toPortalBoleta=()=>{
        setIsBill("ISNOTBILL")
        toPage('portal')
    }

    const puntoVenta=()=>{
      window.open('https://webaccess.tasproventas.com/login','_blank')
    } 
    function click( event ){
      window.open(event.target.attributes.link.value,'_blank')
    }
    if(!authenticated) return (<></>)

    if(authenticated)
    return(
      <div style={{display:'flex',flexGrow:'1',flexDirection:'column', minHeight:'100vh',justifyContent:'center',alignItems:'center',backgroundColor:'rgb(241, 241, 241)'}}>
        {news&&
        <Carousel  
            animation={'slide'}
            autoplay={true}
            interval={4000}
            stopAutoPlayOnHover={false}

            navButtonsProps={{          // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
              style: {
                  backgroundColor: '#101070',
                  borderRadius: 0
              }
            }} 
            navButtonsAlwaysVisible={false}
              indicatorIconButtonProps={{
                  style: {
                      padding: '5px',    // 1
                      color: '#afafaf',
                  }
                }}
              activeIndicatorIconButtonProps={{
                  style: {
                      color: "#101070"
                  }
                }}
        >
        {
            news.map((el,index)=>{
                return(
                    <Paper className={classes.row} key={index}>
                        <div className={classes.column}>
                            <img src={el.logoUrl} ></img>
                            <div className={classes.homeTitle}>{el.title}</div>
                            <div className={classes.homeSubTitle}>{el.subTitle}</div>
                            <button className={classes.blueButton} onClick={click} link={el.buttonLink}>{el.buttonLabel}</button>
                        </div>
                        <div className={classes.column}>
                            <img src={el.pictureUrl} className={classes.banner}></img>
                        </div>
                    </Paper>
                )

            })
        }
        </Carousel>
        }
        <div style={{justifyContent:'center', display:'flex', alignItems:'center'}}>
            <h2>¿Qué quieres hacer hoy?</h2>
        </div>
        <div style={{justifyContent:'center', display:'flex', alignItems:'center'}}>
            <button onClick={toPortalBoleta} className={classes.submitButton}>Boletas</button>
            {
              localStorage.getItem("hasIntegrationsRole") === "true" &&
              <button onClick={toPortalFactura} className={classes.submitButton}>Facturas</button>
            }
            <button onClick={puntoVenta} className={classes.submitButton}>Punto de Venta</button>
            </div>
        </div>
    )
}

export default HomeView